import { Button } from '@/components/Button';
import { Icon, IconVariant } from '@/components/Icon';
import RegionalMap from '@/components/RegionalMap';
import {
  StateSelectorList,
  mapStateSelectorPropsToList,
} from '@/helpers/mapStateSelectorPropsToList';
import classnames from '@/utilities/classnames';
import React from 'react';

export interface StateSelectorProps {
  title?: string;
  BadenWuerttemberg?: string;
  Bayern?: string;
  Berlin?: string;
  Brandenburg?: string;
  Bremen?: string;
  Hamburg?: string;
  Hessen?: string;
  MecklenburgVorpommern?: string;
  Niedersachsen?: string;
  NordrheinWestfalen?: string;
  RheinlandPfalz?: string;
  Sachsen?: string;
  SachsenAnhalt?: string;
  SchleswigHolstein?: string;
  Saarland?: string;
  Thueringen?: string;
}

interface StateSelectorState {
  selectedState: string | null;
}

export default class StateSelector extends React.Component<
  StateSelectorProps,
  StateSelectorState
> {
  private stateSelectorList: StateSelectorList = [];

  constructor(props) {
    super(props);
    this.stateSelectorList = mapStateSelectorPropsToList(this.props).sort(
      (stateA, stateB) =>
        stateA.name > stateB.name ? 1 : stateA.name < stateB.name ? -1 : 0
    );
    this.state = {
      selectedState: null,
    };
  }

  private get url(): string {
    const selected = this.stateSelectorList.find(
      (state) => state.name === this.state.selectedState
    );
    if (selected) {
      return selected.url;
    } else {
      return '#';
    }
  }

  private handleOnChange = (value: string) => {
    this.setState({ selectedState: value });
  };

  private handleOnClick = ($event: React.MouseEvent<HTMLAnchorElement>) => {
    if (this.url === '#') {
      $event.preventDefault();
      $event.stopPropagation();
    }
  };

  render(): JSX.Element {
    return (
      <div className="StateSelector box box--large-padding">
        <div className="StateSelector__content">
          <div className="StateSelector__map">
            <RegionalMap selectedState={this.state.selectedState} />
          </div>
          <div className="StateSelector__states">
            <span className="StateSelector__title">
              {this.props.title || 'Wählen Sie Ihr Bundesland'}
            </span>
            <div
              className="StateSelector__stateList"
              tabIndex={0}
              role="listbox"
              aria-label={this.props.title || 'Wählen Sie Ihr Bundesland'}
            >
              {this.stateSelectorList.map((state, idx) => (
                <div
                  key={idx}
                  className={classnames('StateSelector__item', {
                    'StateSelector__item--selected':
                      this.state.selectedState === state.name,
                  })}
                  onClick={() => this.handleOnChange(state.name)}
                  role="option"
                  aria-selected={this.state.selectedState === state.name}
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      this.handleOnChange(state.name);
                    }
                  }}
                >
                  {state.name}
                </div>
              ))}
            </div>
            <a
              href={this.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={($event) => this.handleOnClick($event)}
            >
              <Button
                variant={Button.Variant.Primary}
                disabled={this.state.selectedState === null}
                ariaLabel="Webseite aufrufen (öffnet neues Fenster)"
                tabIndex={-1}
              >
                <span>Webseite aufrufen</span>
                <Icon variant={IconVariant.External} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
